import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-placeholders-1',
  templateUrl: './1.component.html',
  styleUrls: ['./1.component.scss'],
})
export class VbPlaceholders1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
